export default {
  article_hero_cta: '阅读全文',
  article_label: '独家爆料',
  article_comments_label: '网友评论',
  article_comments_title1: '瓜友热评',
  article_comments_title2: '真实反馈',
  article_comments_subtitle: '来看看大家都怎么说',
  article_relatedCta_title: '还有这些瓜没吃',
  article_relatedCta_subtitle: '别急着走，这些同样精彩',
  article_relatedCta_button: '继续吃瓜',
};